module.exports = __webpack_public_path__ + "img/Admin.f7e50f4b.svg";